/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2025-01-19 10:56:30
 **/
/* eslint @typescript-eslint/no-inferrable-types: 0 */
/* eslint @typescript-eslint/no-explicit-any: 0 */

import isNil from "lodash-es/isNil";
import { NormalCrypto } from "@/crypto";

const DataStorePrivate = {
	get(storage: Storage, key: string, defValue: any = false, isSecure: boolean = false) {
		let result = storage.getItem(key);
		if (isNil(result)) {
			return defValue;
		}
		try {
			if (result === "true" || result === "false") {
				result = JSON.parse(result);
			}
			if (result?.trim().startsWith("{")) {
				result = JSON.parse(result);
			}
			if (isSecure) {
				result = NormalCrypto.decrypt(result);
			}
		} catch {
			result = defValue;
		}
		return result;
	},
	async set(storage: Storage, key: string, value: any, isSecure: boolean = false) {
		if (value !== null) {
			if (typeof value === "function") {
				value = await value();
			}
			if (typeof value === "object") {
				value = JSON.stringify(value);
			}
			storage.setItem(key, !isSecure ? value : NormalCrypto.encrypt(value));
		} else {
			this.remove(storage, key);
		}
	},
	remove(storage: Storage, key: string) {
		storage.removeItem(key);
	}
};
export default DataStorePrivate;
